import { CUSTOM_FIELD, ENTRY_POINT_EDIT } from 'view/common/forge-ui/constants';
import { fireOperationalEvent, fireTrackEvent } from 'view/forge-ui-analytics/common';
import { MODULE_TYPE_EXTENSION, OPERATIONAL_ACTIONS, TRACK_ACTIONS } from 'view/forge-ui-analytics/common/constants';
import { getEventId } from 'view/forge-ui-analytics/common/utils';
import type { AnalyticsAttributes, Source } from 'view/forge-ui-analytics/common/types';

export const fireOperationalEditFailedEvent = (source: Source, attributes?: AnalyticsAttributes) =>
    fireOperationalEvent(OPERATIONAL_ACTIONS.EDIT_FAILED, {
        attributes,
        source,
        id: getEventId({
            module: CUSTOM_FIELD,
            moduleType: MODULE_TYPE_EXTENSION,
            entryPoint: ENTRY_POINT_EDIT,
        }),
    });

export const fireTrackEditedEvent = (source: Source, attributes?: AnalyticsAttributes) =>
    fireTrackEvent(TRACK_ACTIONS.EDITED, {
        attributes,
        source,
        id: getEventId({
            module: CUSTOM_FIELD,
            moduleType: MODULE_TYPE_EXTENSION,
            entryPoint: ENTRY_POINT_EDIT,
        }),
    });
